import { render, staticRenderFns } from "./companyIndex.vue?vue&type=template&id=256004f6"
import script from "./companyIndex.vue?vue&type=script&lang=js"
export * from "./companyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports